export default __webpack_public_path__ + "media/images/cta_blocks/send_invitations-dca9aebe2f1224f0658feaa913425ed4.jpg";